import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=8988a3b8&scoped=true&"
import script from "./editTable.vue?vue&type=script&lang=js&"
export * from "./editTable.vue?vue&type=script&lang=js&"
import style0 from "./editTable.vue?vue&type=style&index=0&id=8988a3b8&prod&lang=less&"
import style1 from "./editTable.vue?vue&type=style&index=1&id=8988a3b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8988a3b8",
  null
  
)

export default component.exports